import { ILoginPage } from '../../../../models/profile/login-page.model';
import { ILoginService } from '../../../../services/profile/login/login-service';
import { ILoginResponse } from '../../../../services/profile/login/login.dto';

export type LoginPageProps = {
  data: ILoginPage;
  identifier?: string;
  isProfileEnabled: boolean;
  redirectFromForgotPassword?: boolean;
  redirectFromResetPassword?: boolean;
  redirectFromSuccessfulRegister?: boolean;
  redirectFromLogout?: boolean;
  redirectionURL?: string;
  loginService: ILoginService;
  signInCallback?: (res: ILoginResponse) => void;
};

export type State = {
  username: string;
  password: string;
  userSignInAttempt: boolean;
  isPasswordEmpty?: boolean;
  isUsernameEmpty?: boolean;
  emptyUserCredentials?: boolean;
  isPasswordVisible: boolean;
  isUserLoggedIn?: boolean;
  isLogInBtnClicked?: boolean;
  isClosableToastVisible?: boolean;
};

export enum LoginPageActionType {
  SetCredentials = 'SetCredentials',
  SignInUser = 'SignInUser',
  SignInAttempt = 'SignInAttempt',
  TogglePasswordVisibility = 'TogglePasswordVidibility',
  UserEmptyCredential = 'UserEmptyCredential',
  SetIsLogInBtnClicked = 'SetIsLogInBtnClicked',
  ToggleClosableToast = 'ToggleClosableToast',
}

export type Action =
  | { type: LoginPageActionType.SetCredentials; credentialType: 'username' | 'password'; credential: string }
  | { type: LoginPageActionType.SignInUser; isSuccess: boolean }
  | { type: LoginPageActionType.SignInAttempt }
  | { type: LoginPageActionType.TogglePasswordVisibility }
  | { type: LoginPageActionType.UserEmptyCredential; isUsernameEmpty: boolean; isPasswordEmpty: boolean }
  | { type: LoginPageActionType.SetIsLogInBtnClicked }
  | { type: LoginPageActionType.ToggleClosableToast; isVisible: boolean };
